class Vec {
  constructor(x = 0, y = 0) {
    this.x = x;
    this.y = y;
  }
  get len() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  set len(value) {
    const f = value / this.len;
    this.x *= f;
    this.y *= f;
  }
}

class Rect {
  constructor(x = 0, y = 0) {
    this.pos = new Vec(0, 0);
    this.size = new Vec(x, y);
  }
  get left() {
    return this.pos.x - this.size.x / 2;
  }
  get right() {
    return this.pos.x + this.size.x / 2;
  }
  get top() {
    return this.pos.y - this.size.y / 2;
  }
  get bottom() {
    return this.pos.y + this.size.y / 2;
  }
}

class Ball extends Rect {
  constructor() {
    super(65, 65);
    this.vel = new Vec;
  }
  update(dt) {
    this.vel.y = (this.pos.y - this._lastPos.y) / dt;
    this._lastPos.y = this.pos.y;
  }
}

class Player extends Rect {
  constructor() {
    super(10, 100);
    this.vel = new Vec;
    this.score = 0;

    this._lastPos = new Vec;
  }
  update(dt) {
    this.vel.y = (this.pos.y - this._lastPos.y) / dt;
    this._lastPos.y = this.pos.y;
  }
}

class Pong {
  constructor(canvas) {
    this._canvas = canvas;
    this._context = canvas.getContext('2d');

    this.readyAIPaddle = false;
    this.diff = 10;
    this.image = this._canvas.closest('.pongContainer').querySelector('.toddImage');
    this.initialSpeed = this._canvas.closest('.pongContainer').querySelector('.toddSpeed:checked').value;
    this.ball = new Ball;

    this.players = [
      new Player,
      new Player,
    ];

    this.players[0].pos.x = 15;
    this.players[1].pos.x = this._canvas.width - 15;
    this.players.forEach(p => p.pos.y = this._canvas.height / 2);

    let lastTime = null;
    this._frameCallback = (millis) => {
      if (lastTime !== null) {
        const diff = millis - lastTime;
        this.update(diff / 1000);
      }
      lastTime = millis;
      requestAnimationFrame(this._frameCallback);
    };

    this.CHAR_PIXEL = 10;
    this.CHARS = [
      '111101101101111',
      '010010010010010',
      '111001111100111',
      '111001111001111',
      '101101111001001',
      '111100111001111',
      '111100111101111',
      '111001001001001',
      '111101111101111',
      '111101111001111',
    ].map(str => {
      const canvas = document.createElement('canvas');
      const s = this.CHAR_PIXEL;
      canvas.height = s * 5;
      canvas.width = s * 3;
      const context = canvas.getContext('2d');
      context.fillStyle = '#fff';
      str.split('').forEach((fill, i) => {
        if (fill === '1') {
          context.fillRect((i % 3) * s, (i / 3 | 0) * s, s, s);
        }
      });
      return canvas;
    });

    this.reset();
  }
  clear() {
    this._context.fillStyle = '#1D2643';
    this._context.fillRect(0, 0, this._canvas.width, this._canvas.height);
  }
  collide(player, i, ball) {
    /* if (player.left < ball.right && player.right > ball.left &&
      player.top < ball.bottom && player.bottom > ball.top) {
      ball.vel.x = -ball.vel.x * 1.05;
      const len = ball.vel.len;
      ball.vel.y += player.vel.y * .2;
      ball.vel.len = len;
    } */
    // if (((i == 1 && player.left < ball.right) || (i== 0 && player.right > ball.left)) && player.top < ball.bottom && player.bottom > ball.top) {
    if (player.left < ball.right && player.right > ball.left &&
      player.top < ball.bottom && player.bottom > ball.top) {
      ball.pos.x = i == 1 ? player.left - (ball.size.x / 2) : player.right + (ball.size.x / 2);
      ball.vel.x = -ball.vel.x;
      const len = ball.vel.len;
      ball.vel.y += player.vel.y * .2;
      ball.vel.len = len;
      this.readyAIPaddle = i == 1 ? false : true;
    }
  }
  draw() {
    this.clear();
    this.drawImg(this.ball);
    this.players.forEach(player => this.drawRect(player));

    this.drawScore();
  }
  drawArc(rect) {
    this._context.fillStyle = '#fff';
    this._context.beginPath();
    this._context.arc(rect.left, rect.top, rect.size.x, 0, 2 * Math.PI);
    this._context.fill();
  }
  drawImg(rect) {
    if(this.image) {
      rect.size.x = rect.size.y * (this.image.width / this.image.height)
      this._context.drawImage(this.image, rect.left, rect.top, rect.size.x, rect.size.y);
    } else {
      this.drawArc(rect);
    }
  }
  drawRect(rect) {
    this._context.fillStyle = '#fff';
    this._context.fillRect(rect.left, rect.top, rect.size.x, rect.size.y);
  }
  drawScore() {
    const align = this._canvas.width / 3;
    const cw = this.CHAR_PIXEL * 4;
    this.players.forEach((player, index) => {
      const chars = player.score.toString().split('');
      const offset = align * (index + 1) - (cw * chars.length / 2) + this.CHAR_PIXEL / 2;
      chars.forEach((char, pos) => {
        this._context.drawImage(this.CHARS[char | 0], offset + pos * cw, 20);
      });
    });
  }
  play() {
    const b = this.ball;
    if (b.vel.x === 0 && b.vel.y === 0) {
      b.vel.x = 200 * (Math.random() > .5 ? 1 : -1);
      b.vel.y = 200 * (Math.random() * 2 - 1);
      b.vel.len = this.initialSpeed;
    }
  }
  reset() {
    const b = this.ball;
    b.vel.x = 0;
    b.vel.y = 0;
    b.pos.x = this._canvas.width / 2;
    b.pos.y = this._canvas.height / 2;
    this.image = this._canvas.closest('.pongContainer').querySelector('.toddImage');
    this.initialSpeed = this._canvas.closest('.pongContainer').querySelector('.toddSpeed:checked').value
  }
  start() {
    requestAnimationFrame(this._frameCallback);
  }
  moveUp(vel) {
    if(this.players[0].pos.y > 0) this.players[0].pos.y -= vel;
  }
  moveDown(vel) {
    if(this.players[0].pos.y < this._canvas.height) this.players[0].pos.y += vel;
  }
  restart() {
    this.players[0].score = 0
    this.players[1].score = 0
    this.reset();
  }
  update(dt) {
    const cvs = this._canvas;
    const ball = this.ball;
    const ballXBefore = ball.pos.x
    ball.pos.x += ball.vel.x * dt;
    ball.pos.y += ball.vel.y * dt;
    const ballXAfter = ball.pos.x
    this.readyAIPaddle = ballXBefore < ballXAfter

    if (ball.right < 0 || ball.left > cvs.width) {
      ++this.players[ball.vel.x < 0 | 0].score;
      this.reset();
    }

    if (ball.vel.y < 0 && ball.top < 0 ||
      ball.vel.y > 0 && ball.bottom > cvs.height) {
      ball.vel.y = -ball.vel.y;
    }

    if(this.readyAIPaddle && ball.pos.x > (this._canvas.width / 2)) {
      this.diff = (this.players[1].pos.y + (this.players[1].size.y / 2)) - (ball.pos.y + (ball.size.y / 2))
      // this.players[1].pos.y += .3 * this.diff > 0 ? -1 : 1;
      this.players[1].pos.y += (this.initialSpeed / 1000) * this.diff > 0 ? -1 : 1;
    }

    this.players.forEach((player, i) => {
      player.update(dt);
      this.collide(player, i, ball);
    });

    this.moveUp(0);
    this.moveDown(0);
    this.draw();
  }
}
